<template>
    <ds-confirm-dialog
        :is-open="isOpen"
        :title="dialogTitle"
        :message="dialogMessage"
        :confirm-label="$t('funnel.lockUnlock.confirm')"
        :cancel-label="$t('funnel.lockUnlock.cancel')"
        @cancel="closeLockUnlockCampaignModal"
        @confirm="toggleLock"
    />
</template>

<script>

export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        campaignLocked: {
            type: Boolean,
            default: false,
        },
        funnelId: {
            type: Number,
            required: true,
        },
    },
    emits: ['close-lock-unlock-campaign-modal', 'campaign-lock-updated'],
    computed: {
        dialogTitle() {
            return this.campaignLocked
                ? this.$t('funnel.unlock.modal.title')
                : this.$t('funnel.lock.modal.title');
        },

        dialogMessage() {
            return this.campaignLocked
                ? this.$t('funnel.unlock.confirm')
                : this.$t('funnel.lock.confirm');
        },
    },
    methods: {
        closeLockUnlockCampaignModal() {
            this.$emit('close-lock-unlock-campaign-modal');
        },

        async toggleLock() {
            try {
                await this.updateLock();
            } catch (error) {
                this.notifyError(this.$t('funnel.lock.failure'));
            }

            this.closeLockUnlockCampaignModal();
        },

        updateLock() {
            const lockValueBeforeUpdate = this.campaignLocked;

            try {
                this.triggerLockUpdate(!lockValueBeforeUpdate);
            } catch (error) {
                this.notifyError(this.$t('funnel.lock.failure'));
            }
        },

        triggerLockUpdate(locked) {
            this.$emit('campaign-lock-updated', locked);
        },

        notifyError(message) {
            this.$error({ message });
        },
    },
};
</script>
